/*
 * @Author: LiuMeiYu
 * @Date: 2023-04-25 14:31:45
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-05-24 15:50:28
 * @FilePath: \nexcross_b\src\main.js
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
 */
import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// iconfont css
import "./assets/iconfont/iconfont.css";

createApp(App)
  .use(store)
  .use(router)
  .use(ElementPlus, { size: "", zIndex: 3000 })
  .mount("#app");
